export default "__VITE_ASSET__BRYD3vIn__"